module.exports = __webpack_public_path__ + "assets/img/commission0.46e21df9.svg";